import { useMemo } from "react";
import { IUserStatus } from "../UserStatuses.t";

function useIsShowUserStatusWithdrawalLimits(userStatusParams?: IUserStatus) {
    return useMemo(() => {
        const dailyLimitUsd = userStatusParams?.withdrawalLimits?.dailyLimitUsd;
        const monthlyLimitUsd = userStatusParams?.withdrawalLimits?.monthlyLimitUsd;
        return userStatusParams && !(dailyLimitUsd === 0 && monthlyLimitUsd === 0);
    }, [userStatusParams]);
}

export default useIsShowUserStatusWithdrawalLimits;
